import { useEffect, useRef } from "react"
import styled from "styled-components"
import { StyledSvgIcon, TypographyCenter } from "theme/shared"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

type FormSuccessStateProps = {
  title?: string
  subtitle?: string
}

const FormSuccessState = ({
  title = "תודה שפנית אלינו!",
  subtitle = "נשמח ליצור איתך קשר בקרוב",
}: FormSuccessStateProps) => {
  const ref = useRef(null)

  useEffect(() => {
    ref.current?.scrollIntoView({ block: "nearest" })
  }, [])

  return (
    <StyledWrapper ref={ref}>
      <StyledSvgIcon src="/icons/sucssesIcon.svg" w={76} h={76} />
      <TypographyCenter variant="h2" role="alert">
        {title}
      </TypographyCenter>
      <TypographyCenter
        variant="body1"
        style={{
          whiteSpace: "pre-line",
        }}
      >
        {subtitle}
      </TypographyCenter>
    </StyledWrapper>
  )
}

export default FormSuccessState
